define('app/editor/ReportDefinitionView',['require','./ColumnView','glu/itemView','glu/model','./dialogs/SelectColumnsDialogView','glu/dialog','hbs!./ReportDefinitionView.hbs','app/app','glu/util','glu/$'],function(require) {
	'use strict';

	var EditColumnView = require('./ColumnView'),
		ItemView = require('glu/itemView'),
		Model = require('glu/model'),
		SelectColumnsDialogView = require('./dialogs/SelectColumnsDialogView'),
		dialog = require('glu/dialog'),
		tmpl = require('hbs!./ReportDefinitionView.hbs'),
		App = require('app/app'),
		_ = require('glu/util'),
		$ = require('glu/$');

	return ItemView.extend({

		template: tmpl,

		dialog: dialog,

		events: {
			'click [type=submit]': 'runReport',
			'click .select-columns-button': 'openSelectColumnsDialog',
			'change #group-and-aggregate-checkbox': 'toggleGrouped',
			'change #show-count-group-checkbox': 'toggleGroupCount'
		},

		initialize: function(options) {
			this.autoRefresh = options.autoRefresh || false;

			this.model = options.model;
			var report = this.model;

			this.listenTo(report, 'change', this.render);

			this.selectColumnsDialogView = new SelectColumnsDialogView({
				className: 'modal-select-columns',
				model: new Model({
					domain: report.get('domain')
				})
			});
		},

		onRender: function() {

			var self = this;
			var report = this.model;

			this.model.columns().each(function(c) {

				// Make sure column isn't hidden
				if (!c.isCountColumn() && !c.get('isHidden')) {
					var viewC = new EditColumnView({
						model: c,
						report: self.model
					});
					var viewCRender = viewC.render().el;

					if (report.isGroupedAndAggregated()) {
						if (c.hasAggregation()) {
							$(viewCRender).addClass('col-aggregate');
						} else {
							$(viewCRender).addClass('col-group');
						}
					} else {
						if (c.isMeasure()) {
							$(viewCRender).addClass('col-measure');
						}
						if (c.isDimension()) {
							$(viewCRender).addClass('col-dimension');
						}
					}

					self.$el.find('#column-edit-fields-rows > ol').append(viewCRender);
				}
			});

			this.refreshClassesAndStates();
		},

		refreshClassesAndStates: function() {
			this.$el.toggleClass('is-grouping-hidden', !this.model.isGroupedAndAggregated());
			var $defineView = this.$el.find('.define-view');
			$defineView.toggleClass('is-runnable', this.model.isRunnable());
			$defineView.toggleClass('is-not-runnable', this.model.isNotRunnable());
			$defineView.toggleClass('has-rows', this.model.hasGroupColumns());
			$defineView.toggleClass('has-no-columns', this.model.hasNoColumns());
			this.$('#group-and-aggregate-checkbox').prop('checked', this.model.isGroupedAndAggregated());
			this.$('#group-and-aggregate-checkbox').prop('disabled', this.model.isNotRunnable());
			this.$('#show-count-group-checkbox').prop('checked', this.model.hasGroupCountColumn());
			this.$('#report-export-csv-button').prop('disabled', this.model.isNotRunnable());
			this.$('#report-save-button').prop('disabled', this.model.isNotRunnable());

			if (!this.autoRefresh) {
				this.updateSubmitButtonState();
			}
		},

		/**
		 * Refresh the data used to populate the report.
		 */
		runReport: function(evt) {
			if (evt) {
				evt.preventDefault();
			}
			this.model.run();
		},

		openSelectColumnsDialog: function(e) {
			var self = this;

			if (e) {
				e.preventDefault();
			}
			var idsInReport = [];

			this.model.eachVisibleColumn(function(column) {
				idsInReport.push(column.fieldId());
			});

			if (App && App.segments && App.segments.fetch) {
				App.segments.fetch().then(function() {
					self.domainSegments = _.where(App.segments.toJSON(), {
						domainId: self.model.get('domain').get('id')
					});

					// renew the view, otherwise events are not picked up
					if (self.selectColumnsDialogView) {
						self.selectColumnsDialogView.remove();
						var report = self.model;
						self.selectColumnsDialogView = new SelectColumnsDialogView({
							className: 'modal-select-columns',
							model: new Model({
								domain: report.get('domain'),
								segments: self.domainSegments,
								report: report
							})
						});

						self.listenTo(self.selectColumnsDialogView, 'selectFields', function(ids, virtualColumns, segments) {
							_.each(ids, function(id) {
								report.addColumnById(id);
							});

							_.each(virtualColumns, function(vCol) {
								report.addVirtualColumnAsColumn(vCol);
							});

							_.each(segments, function(id) {
								report.addSegmentAsColumnById(id);
							});

							self.dialog.close();
							report.set('isDirty', true);
							self.appBus.trigger('refresh');
						});
					}
					self.dialog.open(self.selectColumnsDialogView, 'Select Columns');
				});
			}
		},

		submitButton: function() {
			return this.$el.find('[type=submit]');
		},

		enableSubmitButton: function() {
			this.submitButton().removeAttr('disabled');
		},

		disableSubmitButton: function() {
			this.submitButton().attr('disabled', 'disabled');
		},

		isSubmitButtonEnabled: function() {
			return this.submitButton().is(':enabled');
		},

		updateSubmitButtonState: function() {
			if (this.model.isRunnable()) {
				this.enableSubmitButton();
			} else {
				this.disableSubmitButton();
			}
		},

		isGroupedAndAggregated: function() {
			return this.model.isGroupedAndAggregated();
		},

		hasGroupCountColumn: function() {
			return this.model.hasGroupCountColumn();
		},

		toggleGrouped: function(evt) {
			evt.preventDefault();
			this.model.setGroupedAndAggregated(this.$(evt.target).is(':checked'));
			this.$el.toggleClass('is-grouping-hidden', !this.model.isGroupedAndAggregated());
			this.appBus.trigger('refresh');
		},

		toggleGroupCount: function(evt) {
			evt.preventDefault();
			if (this.$(evt.target).is(':checked')) {
				this.model.addGroupCountColumn();
			} else {
				this.model.removeGroupCountColumn();
			}
			this.appBus.trigger('refresh');
		},

		templateHelpers: function() {
			var self = this;

			return {
				autoRefresh: self.autoRefresh
			};
		},

		serializeData: function() {
			return this;
		}

	});

});

